<template>
    <div>
        <div>
            <h5>
                Resource types
            </h5>
            <Multiselect
                v-model="resourceTypes"
                placeholder="Select a type..."
                :options="resourceTypeOptions"
                :multiple="true"
                label="label"
                select-label="⏎"
                selected-label=""
            />
        </div>
        <div class="mt-3">
            <h5>
                Cost types
            </h5>
            <CostTypeSelect
                v-model="costTypes"
                :multiple="true"
            />
        </div>
    </div>
</template>
<script>
import { sync } from 'vuex-pathify';
import Multiselect from 'vue-multiselect';
import CostTypeSelect from '@/components/CostTypeSelect.vue';

export default {
    components: { CostTypeSelect, Multiselect },
    data() {
        return {
            resourceTypeOptions: [],
        };
    },
    computed: {
        costTypes: sync('document/field@options.cost_types'),
        resourceTypes: sync('document/field@options.resource_types'),
    },
    async mounted() {
        this.resourceTypeOptions = await this.$store.dispatch('selects/getResourceTypes', { supplierId: '' });
    },
};
</script>
